import { Link } from "react-router-dom";
import {
  FaLeaf,
  FaPalette,
  FaCheckCircle,
  FaRocket,
  FaArrowRight,
  FaPlayCircle,
  FaStore,
  FaUsers,
  FaBuilding,
  FaBoxes,
  FaUserTie,
  FaBabyCarriage,
  FaChartLine,
  FaHeart,
  FaTshirt,
} from "react-icons/fa";
import "../styles/AboutPage.css";

export default function AboutPage() {
  return (
    <div className="about-page">
      {/* ── Hero ─────────────────────────────────────────────── */}
      <div className="about-hero">
        <div className="about-hero-overlay" />
        <div className="about-hero-content">
          <span className="about-hero-tag">Since 1961</span>
          <h1>
            KKB & Co.
            <br />
            Tradition through Generations
          </h1>
          <p>Diamond Jubilee in Textile Excellence</p>
        </div>
      </div>

      {/* ── Who We Are ───────────────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="about-story">
            <div className="about-story-img-wrap">
              <img
                src="https://kkbstore.com/wp-content/uploads/2023/12/2023-05-30.jpg"
                alt="KKB & Co. Textiles"
              />
              <div className="about-story-img-badge">Est. 1961</div>
            </div>
            <div className="about-story-content">
              <span className="section-eyebrow">Who We Are</span>
              <h2 className="section-title">
                Diamond Jubilee
                <br />
                in Textile Excellence
              </h2>
              <p className="lead-text">
                Proudly speaking, we KKB &amp; CO completed 'Diamond Jubilee' in
                the textile field. The word 'Diamond' originated from Greek
                'adamus' — meaning 'unconquerable'. This is the perfect epithet
                for our journey.
              </p>
              <p>
                With our spirit of trust, quality and perseverance, we have been
                continuously striving to reinvent ourselves in tune with
                changing time. K.K.Balusamy &amp; Co had less than one lakh
                turnover in the year 1961 and has now turned into a multicrore
                company backed by the support and tireless efforts of our staff
                and the patronage of valuable customers and versatile vendors.
              </p>
              <Link className="about-btn" to="/collection">
                Shop Our Collections <FaArrowRight className="btn-icon" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats Strip ──────────────────────────────────────── */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {[
              {
                number: "63+",
                label: "Years of Experience",
                icon: <FaBabyCarriage />,
              },
              {
                number: "10,000+",
                label: "Happy Customers",
                icon: <FaUsers />,
              },
              { number: "600+", label: "Whole Sellers", icon: <FaStore /> },
              { number: "101+", label: "Products", icon: <FaTshirt /> },
              { number: "75+", label: "Employees", icon: <FaUserTie /> },
              {
                number: "27,000+",
                label: "Pincode Coverage",
                icon: <FaChartLine />,
              },
            ].map((s) => (
              <div className="stat-card" key={s.label}>
                <div className="stat-icon">{s.icon}</div>
                <div className="stat-number">{s.number}</div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Founder ──────────────────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="team-section">
            <div className="team-img-wrap">
              <img
                src="https://kkbstore.com/wp-content/uploads/2023/12/Screenshot-2023-12-09-104033.jpg"
                alt="Mr. K.K. Balusamy"
              />
              <div className="team-name-plate">
                <div className="team-name">MR. K.K. BALUSAMY</div>
                <div className="team-role">CEO &amp; Founder</div>
              </div>
            </div>
            <div className="team-content">
              <span className="section-eyebrow">About Founder</span>
              <h2 className="section-title">
                Saadhanai Chemmal
                <br />
                <em>The Kaili King</em>
              </h2>
              <p className="lead-text">
                Our founder &amp; chairman was born January 1946. At age of 16,
                owing to family situations, he sacrificed his passion to become
                a Surgeon and ventured into textile business and started
                K.K.Balusamy &amp; Co.
              </p>
              <p>
                He is fondly known as <strong>'Kaili King'</strong> for his
                contributions to the Textile industry — more precisely for his
                contribution towards invention of 'Printed Lungi' that changed
                the Lungi market. His passion has made him continuously
                challenge the way things are done. He brought wax print, art
                print, spray print and Procion print to market. He gradually
                evolved printing methods from Wooden Block to Table and then to
                Rotary.
              </p>
              <p>
                Being an ingrained philanthropist, he never kept his ideas and
                inventions to himself — rather he shared knowledge and helped
                all kith and kin grow along with him. The 'Kaili King', also
                known as
                <strong>'Kalvi Thanthai'</strong>, has handed over the reign to
                his son Mr. Arun Kumar Balusamy and his daughter Mrs. Manjula
                Vidhya Shankar, and stays busy serving the society through
                educational institutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Divider ──────────────────────────────────────────── */}
      <div className="section-divider">
        <span>Our Leadership</span>
      </div>

      {/* ── Managing Director ────────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="team-section team-section--reverse">
            <div className="team-content">
              <span className="section-eyebrow">About Managing Director</span>
              <h2 className="section-title">
                Mr. Arun Kumar
                <br />
                Balusamy
              </h2>
              <p className="lead-text">
                Born in 1979, he completed his BBM Graduation from PSG,
                Coimbatore. He joined his family business and stepped into M/S
                K.K.Balusamy &amp; Co, continuously enriching business knowledge
                through active involvement.
              </p>
              <p>
                Being a strong believer in quality and trust, he is keen in
                reinventing the product line — stepping into manufacturing
                knitted garments, formals, Dhotis and Home tex products. His
                strong acumen to assess the changing environment provides the
                business with a visionary outlook. He initiated own weaving
                units to meet supply demand without compromise in quality,
                turning the concern into a more self-reliant manufacturer of
                grey material, Knitting Products, Home Tex Products and woven
                products.
              </p>
            </div>
            <div className="team-img-wrap">
              <img
                src="https://kkbstore.com/wp-content/uploads/2023/12/Screenshot-2023-12-09-103934.jpg"
                alt="Mr. Arun Kumar Balusamy"
              />
              <div className="team-name-plate">
                <div className="team-name">MR. ARUNKUMAR BALUSAMY</div>
                <div className="team-role">Managing Director</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Executive Director ───────────────────────────────── */}
      <section className="section-pad" style={{ background: "var(--cream)" }}>
        <div className="container">
          <div className="team-section">
            <div className="team-img-wrap">
              <img
                src="https://kkbstore.com/wp-content/uploads/2023/12/Screenshot-2023-12-09-103911.jpg"
                alt="Mrs. Manjula Vidhya Shankar"
              />
              <div className="team-name-plate">
                <div className="team-name">MRS. MANJULA VIDHYA SHANKAR</div>
                <div className="team-role">Executive Director</div>
              </div>
            </div>
            <div className="team-content">
              <span className="section-eyebrow">About Executive Director</span>
              <h2 className="section-title">
                Mrs. Manjula
                <br />
                Vidhya Shankar
              </h2>
              <p className="lead-text">
                Born in 1976 and pursuing BA English Literature, she is a
                natural leader with a commitment to deliver the best in every
                aspect of life. Her entrepreneurial venture was established in
                2007.
              </p>
              <p>
                Now serving as Executive Director in K.K.Balusamy &amp; Co., her
                unique business comprehension and strong appreciation for
                garments drives a passionate mission to carve a place in the
                market. Being a strong advocate of systematic order, she has
                made administration smoother and faster. A voracious reader, she
                takes inspiration from various sources and implements new
                techniques and methods to make the company futuristic. Her
                resourcefulness and novel ideas have added more confidence and
                strength to the company.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Production Line ──────────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: 56 }}>
            <span className="section-eyebrow">Our Process</span>
            <h2 className="section-title" style={{ textAlign: "center" }}>
              Line of Production
            </h2>
          </div>

          <div className="production-block">
            <div className="production-label">Before MD Stepping</div>
            <div className="production-steps">
              {["Purchase", "Printing", "Folding", "Packing", "Dispatch"].map(
                (step, i) => (
                  <div className="production-step" key={step}>
                    <div className="step-num">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="step-title">{step}</div>
                    {i < 4 && <div className="step-arrow">→</div>}
                  </div>
                ),
              )}
            </div>
          </div>

          <div className="production-block production-block--alt">
            <div className="production-label">After MD Stepping</div>
            <div className="production-steps">
              {[
                "Yarn Procurement",
                "Weaving",
                "Printing",
                "Standard Measured Folding",
                "Machine Packing",
                "Dispatch",
              ].map((step, i) => (
                <div className="production-step" key={step}>
                  <div className="step-num">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="step-title">{step}</div>
                  {i < 5 && <div className="step-arrow">→</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Values ───────────────────────────────────────────── */}
      <section className="section-pad" style={{ background: "var(--cream)" }}>
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <span className="section-eyebrow">Our Values</span>
            <h2 className="section-title" style={{ textAlign: "center" }}>
              The principles that guide
              <br />
              every thread we weave
            </h2>
          </div>
          <div className="values-grid">
            {[
              {
                icon: <FaLeaf />,
                title: "Pure Cotton",
                desc: "We use only 100% combed compact cotton — skin-friendly, breathable, and long-lasting.",
              },
              {
                icon: <FaPalette />,
                title: "Bold Designs",
                desc: "From subtle classics to vibrant prints, our design team crafts patterns that stand out.",
              },
              {
                icon: <FaCheckCircle />,
                title: "Quality First",
                desc: "Every product is checked for colour, weave, and finish before it reaches you.",
              },
              {
                icon: <FaRocket />,
                title: "Innovation",
                desc: "We're constantly pushing boundaries — first in segment for washed ready-to-wear dhothis.",
              },
            ].map((v) => (
              <div className="value-card" key={v.title}>
                <div className="value-icon">{v.icon}</div>
                <h3 className="value-title">{v.title}</h3>
                <p className="value-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── YouTube Video ─────────────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <span className="section-eyebrow">Our Story in Motion</span>
            <h2 className="section-title" style={{ textAlign: "center" }}>
              KKB — Introduction
            </h2>
          </div>
          <div className="video-wrap">
            <iframe
              src="https://www.youtube.com/embed/-iZm5iCMLyM?controls=1&rel=0"
              title="KKB Introduction"
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
        </div>
      </section>

      {/* ── CTA Banner ───────────────────────────────────────── */}
      <div className="about-cta">
        <div className="container">
          <div className="about-cta-inner">
            <div>
              <h2>Ready to Experience KKB Comfort?</h2>
              <p>Browse our latest collections and find your perfect style.</p>
            </div>
            <Link className="about-cta-btn" to="/collection">
              Shop All Products <FaArrowRight className="btn-icon" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
